export default __webpack_public_path__ + "3afefbc9f92e43ce51557d02c8d60bfe.woff2";